import axios from "axios";

const Api = axios.create({
  baseURL: "https://dacodebackend.vercel.app/api",
});

export default Api;
